/**
 * WERK — Verhalten der Seitenvorlage (sections/rxk-wk-*.liquid).
 *
 * Reiter (Kollektion), Zurueck/Weiter (Film), Kartenstapel (Galerie) und
 * das Zaehlwerk (Werk). Alles ohne Abhaengigkeiten; ohne Skript bleibt
 * jeweils der erste Eintrag sichtbar und die Ziffern stehen auf 0.
 */
(function () {
  'use strict';

  function zeige(root, i) {
    root.querySelectorAll('[data-wk-panel]').forEach(function (p) {
      p.toggleAttribute('data-wk-aktiv', p.getAttribute('data-wk-panel') === String(i));
    });
  }
  function zweistellig(n) {
    return String(n).padStart(2, '0');
  }

  /* Kollektion: Reiter schalten Bild und Text um */
  document.querySelectorAll('[data-wk-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-wk-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-wk-tab');
        zeige(root, i);
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t.getAttribute('data-wk-tab') === i ? 'true' : 'false');
        });
      });
    });
  });

  /* Film: Zurueck/Weiter ueber die Eintraege, Zaehler zaehlt mit */
  document.querySelectorAll('[data-wk-film]').forEach(function (root) {
    var n = root.querySelectorAll('.wk-film__eintrag').length;
    if (n < 2) return;
    var i = 0;
    var zaehler = root.querySelector('[data-wk-aktuell]');
    function los() {
      root.querySelectorAll('video').forEach(function (v) { v.pause(); });
      zeige(root, i);
      if (zaehler) zaehler.textContent = zweistellig(i + 1);
    }
    root.querySelector('[data-wk-zurueck]').addEventListener('click', function () { i = (i - 1 + n) % n; los(); });
    root.querySelector('[data-wk-weiter]').addEventListener('click', function () { i = (i + 1) % n; los(); });
  });

  /* Galerie: Kartenstapel. Die aktive Karte liegt vorn, jede weitere
     dahinter ist um den Faktor 0,78 kleiner und rueckt nach oben. */
  document.querySelectorAll('[data-wk-galerie]').forEach(function (root) {
    var karten = Array.prototype.slice.call(root.querySelectorAll('.wk-gal__karte'));
    var n = karten.length;
    if (!n) return;
    var i = 0;
    var zaehler = root.querySelector('[data-wk-aktuell]');
    function lege() {
      karten.forEach(function (k, idx) {
        var d = (idx - i + n) % n;
        var s = Math.pow(0.78, d);
        k.style.transform = 'translate(-50%, ' + (-(1 - s) * 350).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
        k.style.zIndex = String(n - d);
        k.style.opacity = d < 5 ? '1' : '0';
        k.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
      });
      if (zaehler) zaehler.textContent = zweistellig(i + 1);
    }
    var zurueck = root.querySelector('[data-wk-zurueck]');
    var weiter = root.querySelector('[data-wk-weiter]');
    if (zurueck) zurueck.addEventListener('click', function () { i = (i - 1 + n) % n; lege(); });
    if (weiter) weiter.addEventListener('click', function () { i = (i + 1) % n; lege(); });
    karten.forEach(function (k, idx) {
      k.addEventListener('click', function () { if (idx !== i) { i = idx; lege(); } });
    });
    lege();
  });

  /* Zaehlwerk: rollt jede Ziffer auf ihren Zielwert, sobald der Abschnitt
     zu einem Drittel sichtbar ist. Einmalig. */
  var werke = document.querySelectorAll('[data-wk-zaehlwerk]');
  if (werke.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.querySelectorAll('[data-wk-ziel]').forEach(function (z, k) {
          var rolle = z.querySelector('.wk-werk__rolle');
          if (!rolle) return;
          rolle.style.transitionDelay = (k * 140) + 'ms';
          rolle.style.translate = '0 ' + (-Number(z.getAttribute('data-wk-ziel')) * 0.8) + 'em';
        });
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    werke.forEach(function (el) { io.observe(el); });
  } else {
    werke.forEach(function (el) {
      el.querySelectorAll('[data-wk-ziel]').forEach(function (z) {
        var rolle = z.querySelector('.wk-werk__rolle');
        if (rolle) rolle.style.translate = '0 ' + (-Number(z.getAttribute('data-wk-ziel')) * 0.8) + 'em';
      });
    });
  }
})();
